module.exports = __webpack_public_path__ + "img/Frame 717.a5f9a7fa.png";